// extracted by mini-css-extract-plugin
export default {"innerContainer":"AddTacticPanel_innerContainer__z1TQa"};